var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-fat-radio-item',{staticClass:"new-shipment-types-item",attrs:{"active":_vm.active,"title":_vm.title}},[_c('div',{staticClass:"new-shipment-types-item__container"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }